import { c as _c } from "react/compiler-runtime";
import { CreateProxyRateWaveDropAction } from "@/entities/IProxy";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
export default function ProxyCreateActionConfigRateWaveDrop(t0) {
  const $ = _c(10);
  const {
    endTime,
    onSubmit,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== endTime || $[1] !== onSubmit) {
    t1 = () => onSubmit({
      action_type: ApiProfileProxyActionType.RateWaveDrop,
      end_time: endTime
    });
    $[0] = endTime;
    $[1] = onSubmit;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSubmit = t1;
  let t2;
  if ($[3] !== onCancel) {
    t2 = <button type="button" onClick={onCancel} className="tw-w-full sm:tw-w-auto tw-flex tw-items-center tw-justify-center tw-relative tw-bg-iron-800 tw-px-3.5 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-text-iron-300 tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[3] = onCancel;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleSubmit) {
    t3 = <button type="button" onClick={handleSubmit} className="tw-w-full sm:tw-w-auto tw-bg-primary-500 tw-px-3.5 tw-py-2.5 tw-text-sm tw-leading-5 tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg hover:tw-bg-primary-600 hover:tw-border-primary-600 tw-transition tw-duration-300 tw-ease-out">Save</button>;
    $[5] = handleSubmit;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-flex tw-items-center tw-justify-end md:tw-justify-start tw-gap-x-3">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}